import React, { useEffect, useRef, useState } from 'react';
import { Breadcrumb, Col } from 'react-bootstrap';
import Row from 'react-bootstrap/esm/Row';
import CompletedQ from './CompletedQ';
import ToolTip from '../../UI/ToolTip';
import { Link, useLocation } from 'react-router-dom';
import userService from '../../app/services/user.service';
import Loader from '../../UI/loader/loader';
import SecBTN from '../../UI/SecBTN';
import NvSir from '../../assets/img/nvsir.png';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import Modals from "../../UI/Modals/Modals";
import classes1 from "../../Components/Questions/Questions.module.css";
import './CompletedQues.css';
// import './CompletedQ.css';

const CompletedQues = props => {
  // const {uid,sid,pid} = useParams()
  const { state } = useLocation();
  const { uid, sid, pid } = state;
  const [qData, setQData] = useState([]);
  const [loading, setLoading] = useState(false);
  //paper Detail popup
  const [showPopUp, setShowPopUp] = useState(false);
  //View Syllabus popup
  const [showPopUp1, setShowPopUp1] = useState(false);
  const [isPrintMode, setIsPrintMode] = useState(false);
  const reportTemplateRef = useRef(null);
  const paperDetailHandler = () => setShowPopUp(true);
  const viewSyllabusHandler = () => setShowPopUp1(true);
  const hideHandler = () => {
    setShowPopUp(false);
    setShowPopUp1(false);
  };


  console.log("User Id", uid, "sid", sid, 'pid', pid)
  useEffect(() => {
    setLoading(true)
    userService.getViewPaper({ uid, sid, pid })
      .then(data => {
        setQData(data.data)

      })
      .then(() => {
        setLoading(false)
        console.log("English Option Data")
      })
      .catch((error) => {
        setLoading(false);
        console.log("error", error);
      });
  }, []);

  useEffect(() => {
    // Listen for print events
    const beforePrint = () => setIsPrintMode(true);
    const afterPrint = () => setIsPrintMode(false);
    window.addEventListener('beforeprint', beforePrint);
    window.addEventListener('afterprint', afterPrint);
    return () => {
      window.removeEventListener('beforeprint', beforePrint);
      window.removeEventListener('afterprint', afterPrint);
    };
  }, [isPrintMode]);

  if (isPrintMode) {
    return (
      <div className="printable paper-container">




        <h2 className="paper-title">Question Paper</h2>

        <div className="paper-card">
          <div className="paper-grid paper-grid-small">
            <div><b>Batch:</b> {qData?.paper_info?.batch_name}</div>
            <div><b>Session:</b> {qData?.paper_info?.Session}</div>
            <div><b>Paper Code:</b> {qData?.paper_info?.paper_id}</div>
            <div><b>Class:</b> {qData?.paper_info?.classes}</div>
            <div><b>Target:</b> {qData?.paper_info?.target}</div>
            <div><b>Phase:</b> {qData?.paper_info?.phase}</div>
            <div><b>Paper Created by:</b> {qData?.paper_info?.creator}</div>
            <div><b>Format:</b> {qData?.paper_info?.paper_format}</div>
            <div><b>Exam Date:</b> {qData?.paper_info?.to_be_held_on}</div>
            {/* <div><b>Questions Assigned:</b> {qData?.paper_info?.creator}</div> */}
            <div><b>Submission Date:</b> {qData?.paper_info?.to_be_completed_by}</div>
            <div><b>Paper Requested On:</b> {qData?.paper_info?.created_on}</div>
            <div><b>Finalize on:</b> {qData?.paper_info?.to_be_final_by}</div>
            <div><b>Center:</b> {qData?.paper_info?.centers}</div>

            {qData?.paper_info?.topic_names && (
              <div className="full-row">
                <b>Syllabus:</b> {qData.paper_info.topic_names}
              </div>
            )}

            {qData?.paper_info?.topic_remarks && (
              <div className="full-row">
                <b>Remarks:</b> {qData.paper_info.topic_remarks}
              </div>
            )}
          </div>
        </div>

        <div className="questions-container">
          {Object.values(qData?.paper_matrix || {}).map((data, index) => (
            <div key={index} className="question-card">

              <div className="question-meta">
                <div><b>Q No.: {data.qno}</b></div>
                <div><b>QID:</b> {data.qid}</div>
                <div><b>Topic:</b> {data.topic_name}</div>
                <div><b>Sub-topic:</b> {data.sub_topic_name}</div>
                <div><b>Level:</b> {data.toughness}</div>
              </div>

              <div className="question-text two-lang">
                <div className="lang-col english">

                  <span dangerouslySetInnerHTML={{ __html: data.q_text }} />
                </div>
                <div className="lang-col hindi">

                  <span dangerouslySetInnerHTML={{ __html: data.q_text_hindi }} />
                </div>


              </div>

              <ol className="option-list two-lang">
                {data.eng_option &&
                  [...new Set(data.eng_option.split("@@@"))].map((engOpt, i) => {
                    const hiOpt = data.h_option?.split("@@@")[i] || "";
                    const optionLabel = String.fromCharCode(65 + i); // A, B, C, D

                    return (
                      <li key={i} className="option-row">
                        {/* OPTION LABEL */}


                        {/* ENGLISH */}
                        <div className="lang-col english">
                          <span className="option-label">{optionLabel}.</span>
                          <span dangerouslySetInnerHTML={{ __html: engOpt }} />
                        </div>

                        {/* HINDI */}
                        <div className="lang-col hindi">
                          <span className="option-label">{optionLabel}.</span>
                          <span dangerouslySetInnerHTML={{ __html: hiOpt }} />
                        </div>
                      </li>
                    );
                  })}
              </ol>


              {/* ANSWER */}
              <div className="answer-row">
                <b>Answer:</b> {data.answer}
              </div>

              {/* SOLUTION */}
              {/* SOLUTION */}
              {(data.sol_text || data.sol_text_hindi) && (
                <div className="solution-row two-lang">
                  <div className="lang english">
                    <b>Sol:</b>
                    <div
                      className="solution-text"
                      dangerouslySetInnerHTML={{ __html: data.sol_text || "" }}
                    />
                  </div>

                  <div className="lang hindi">
                    <b>Sol:</b>
                    <div
                      className="solution-text"
                      dangerouslySetInnerHTML={{ __html: data.sol_text_hindi || "" }}
                    />
                  </div>
                </div>
              )}


            </div>
          ))}
        </div>
      </div>
    );
  }




  const styles = {

  }
  // const handleGeneratePdf = () => {
  // 	const doc = new jsPDF({
  // 		format: 'a4',
  // 		unit: 'px',
  //     compress:true
  // 	});

  // 	// Adding the fonts.
  // 	doc.setFont('Inter-Regular', 'normal');

  // 	doc.html(reportTemplateRef.current, {
  // 		async callback(doc) {
  // 			await doc.save('document');
  // 		},
  //     margin:[10,0,10,0],
  //     html2canvas:  { dpi: 800, letterRendering: true}
  // 	});
  // };
  return (
    <div className="section completed-ques">
      {loading && <Loader />}
      {/* Paper Details */}
      <Modals show={showPopUp} onHide={hideHandler} size="lg">
        <h4 className="mb-4">Paper Details</h4>
        {qData?.paper_info && (
          <Row className="mt-3">
            <Col md={6} sm={12}>
              <b>Paper Code:</b> {qData.paper_info.paper_id}
            </Col>
            <Col md={6} sm={12}>
              <b>Paper Name:</b> {qData.paper_info.paper_name}
            </Col>
            <Col md={6} sm={12}>
              <b>Batch:</b> {qData.paper_info.batch_name || 'NA'}
            </Col>
            <Col md={6} sm={12}>
              <b>Target:</b> {qData.paper_info.target || 'NA'}
            </Col>
            <Col md={6} sm={12}>
              <b>Session:</b> {qData.paper_info.Session || 'NA'}
            </Col>
            <Col md={6} sm={12}>
              <b>Center:</b> {qData.paper_info.centers || 'NA'}
            </Col>
            <Col md={6} sm={12}>
              <b>Class:</b> {qData.paper_info.classes || 'NA'}
            </Col>
            <Col md={6} sm={12}>
              <b>Paper Requested By:</b> {qData.paper_info.creator || 'NA'}
            </Col>
            <Col md={6} sm={12}>
              <b>Paper Requested On:</b> {qData.paper_info.created_on ? new Date(qData.paper_info.created_on).toLocaleString() : 'NA'}
            </Col>
            <Col md={6} sm={12}>
              <b>Format:</b> {qData.paper_info.paper_format || 'NA'}
            </Col>
            <Col md={6} sm={12}>
              <b>Exam On:</b> {qData.paper_info.to_be_held_on || 'NA'}
            </Col>
            <Col md={6} sm={12}>
              <b>Last Date of Submission:</b> {qData.paper_info.to_be_completed_by || 'NA'}
            </Col>
            <Col md={6} sm={12}>
              <b>Phase:</b> {qData.paper_info.phase || 'NA'}
            </Col>
            <Col md={12} sm={12}>
              <div className="d-flex">
                <b>Questions Assigned :</b>
                <div>
                  {qData.paper_matrix && Object.values(qData.paper_matrix).sort((a, b) => a.sec_id - b.sec_id).map((data, idx) => (
                    <div className="d-flex ps-1" key={data.sec_id || idx}>
                      <b>{data.section_name ? `${data.section_name} : ` : ''}</b>
                      <span className="ps-1">{data.question || ''}</span>
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        )}
      </Modals>
      {/* Syllabus */}
      <Modals show={showPopUp1} onHide={hideHandler} size="lg">
        <h4 className="mb-4">Syllabus</h4>
        <p>
          <span className="text-muted">Topic : </span>
          {qData?.paper_info?.topic_names}
        </p>
        <p><span className="text-muted">Remarks : </span>
          {qData?.paper_info?.topic_remarks}</p>
      </Modals>
      <div className="d-flex justify-content-between align-items-center gap-1">
        <div>
          <h4>Questions</h4>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/createPaper">Create Paper</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Completed</Breadcrumb.Item>
            <Breadcrumb.Item active>Questions</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className={""}>

          <SecBTN className="sec-btn" onClick={paperDetailHandler}>
            Paper Details
          </SecBTN>
          <SecBTN className="sec-btn" onClick={viewSyllabusHandler}>
            View Syllabus
          </SecBTN>
          {/* <a
            href={`/createPaper/printView?uid=${uid}&sid=${sid}&pid=${pid}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginRight: '8px' }}
          >
            <SecBTN className="sec-btn1">Print</SecBTN>
          </a> */}
        </div>
      </div>
      <div ref={reportTemplateRef} style={styles.page}>
        <Row className="mx-0" id="printable">
          {qData?.paper_matrix && Object.values(qData?.paper_matrix)?.map((data, i) => (
            <CompletedQ
              key={data.qid || i}
              qid={data?.qid}
              qNo={data?.qno}
              topic={data?.topic_name}
              subTopic={data?.sub_topic_name}
              toughness={data?.toughness}
              question={data?.q_text}
              hindiQuestion={data?.q_text_hindi}
              engOption={data?.eng_option}
              hindiOption={data?.h_option}
              correctAns={data?.answer}
              answer={data?.sol_text}
              hindiAnswer={data?.sol_text_hindi}
            />
          ))}
        </Row>
      </div>
      <div className='d-flex justify-content-center m-3'>
        <Link to='/createPaper/paperMatrix' state={{ "uid": uid, "sid": sid, "pid": pid }}>
          <SecBTN className="sec-btn1 justify-content-center">Edit Matrix</SecBTN>
        </Link>
      </div>
    </div>
  );
}

export default CompletedQues